var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5H17.5V8H17V8.5ZM5 9H17V8H5V9ZM16.5 8.5V13.5H17.5V8.5H16.5Z",
    fill: "#1D6295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNot);
export default __webpack_public_path__ + "static/media/not.b379bd7c9b73d534fc9ea7986a5c4113.svg";
export { ForwardRef as ReactComponent };